// @feature-spec brain/vidmax/feature-specs/usage.md
import { Loader } from "@aix/ui"
import { createFileRoute } from "@tanstack/react-router"
import { lazy, Suspense } from "react"
import AppLayout from "~/layouts/AppLayout"

const LazyTeamUsageHistory = lazy(() => import("~/components/Settings/TeamUsageHistory"))

const breadcrumbItems = [{ label: "Billing" }]

/**
 * https://dashboard.stripe.com/test/products?active=true
 */

const Usage = () => {
  return (
    <Suspense fallback={<Loader />}>
      <LazyTeamUsageHistory />
    </Suspense>
  )
}

function UsagePageWrapper() {
  return (
    <AppLayout>
      <Usage />
    </AppLayout>
  )
}

export const Route = createFileRoute("/usage")({
  component: UsagePageWrapper,
})